<template>
  <div class="home-page-wrapper">
    <div class="home-page fade-transition">

      <div class="top-bar">
        Accesso per le Stazioni Appaltanti
      </div>
      <div class="content-container">
        <div class="info-text">
          <p>
            Il Servizio Supporto Giuridico è rivolto alle stazioni appaltanti ed è articolato in funzioni ad accesso
            riservato ed a libera consultazione.
            L’accesso avviene tramite la registrazione dell’utente alla piattaforma informatica, inserendo i dati
            richiesti, o tramite Spid (Sistema Pubblico di Identità Digitale).
          </p>
          <p>
            I pareri resi dal servizio alle stazioni appaltanti vengono successivamente asseverati dall’Unità Operativa
            di Coordinamento (UOC) istituita presso il Ministero delle infrastrutture e dei trasporti e pubblicati
            nell’apposita banca dati consultabile liberamente online. I pareri forniti hanno natura di atti meramente
            consultivi e non vincolanti per le stazioni appaltanti.
          </p>
          <p>Queste, in sintesi, le operazioni da effettuare per la registrazione:</p>
          <ol>
            <li>Il referente della stazione appaltante (utente) compila il modulo di registrazione con i propri dati e
              della stazione appaltante.</li>
            <li>L’utente stampa, sottoscrive il modulo compilato ed invia lo stesso all'indirizzo
              <strong>assistenzasupportogiuridico@itaca.org</strong>.
            </li>
            <li>L’utente riceve una mail di conferma dell’abilitazione e può conseguentemente accedere al servizio.</li>
            <li>Se si è già registrati si può accedere direttamente al servizio.</li>
          </ol>
        </div>
        <div v-if="!this.$root.user" class="login-button-wrapper">
          <a :href="this.$root.config.VITE_APP_BACKOFFICE_URL + '/auth/sso/login'" class="btn-login-large">
            <i class="bi bi-arrow-bar-up arrow-icon"></i>
            <span class="login-text">Login</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView"
}
</script>

<style scoped>
.home-page-wrapper {
  padding-top: 0;
}

.login-button-wrapper {
  margin-top: 2rem;
}

.btn-login-large {
  display: flex;
  flex-direction: column;
  /* icona sopra, testo sotto */
  align-items: center;
  justify-content: center;
  padding: 3rem 3rem;
  /* pulsante grande */
  gap: 1rem;
  /* spazio tra icona e testo */
  font-size: 1.6rem;
  /* testo dimensione giusta */
  font-weight: bold;
  text-transform: uppercase;
  /* maiuscolo */
  text-decoration: none;
  /* niente sottolineatura */
  color: #fff;
  background-color: #005ea5;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
  width: 20rem;
  height: 9rem;
}

.btn-login-large:hover {
  background-color: #007bff;
  transform: scale(1.03);
}

.arrow-icon {
  font-size: 5rem;
  line-height: 1;
}

/**.top-bar {
  width: 70vw;
  height: 12vw;
  background: linear-gradient(90deg, #005ea5, #007bff);
  color: white;
  font-size: 2rem;
  font-weight: bold;
  text-align: left;
  padding: 6rem 4rem;
  position: relative;
  z-index: 10;
}*/

.top-bar {
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0) 45%),
    linear-gradient(180deg, #2f86ff 0%, #0059b3 45%, #003a7a 100%);
  color: white;
  font-size: 2rem;
  font-weight: bold;
  text-align: left;
  padding: 6rem 4rem;
  z-index: 10;
  padding-left: 20rem;
}

.content-container {
  margin: 2rem auto;
}

.info-text {
  font-size: 1rem;
  line-height: 1.6;
  color: #333;
  width: 68vw;
  position: relative;
  /* necessario per posizionare pulsante dentro */
}

/* Pulsante non fisso, posizionato in basso a sinistra dentro info-text */
.login-button {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-top: 2rem;
}

.login-button a {
  font-size: 1.8rem;
  padding: 1rem 2rem;
}
</style>
